import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Plotly from "plotly.js-dist-min";
import React, { useEffect, useRef } from "react";
const AiBarChart = ({ series, title, x_label, y_label }) => {
    const chartRef = useRef(null);
    useEffect(() => {
        const el = chartRef.current;
        if (!el)
            return;
        const data = series.map((s) => ({
            name: s.name,
            type: "bar",
            x: s.x,
            y: s.y
        }));
        const layout = {
            autosize: true,
            barmode: "group",
            height: 420,
            legend: { orientation: "h", x: 0.5, xanchor: "center", y: -0.15, yanchor: "top" },
            margin: { b: 80, l: 60, r: 20, t: 10 },
            paper_bgcolor: "transparent",
            xaxis: { title: x_label ?? "" },
            yaxis: { title: y_label ?? "" }
        };
        Plotly.newPlot(el, data, layout, { displayModeBar: false, responsive: true });
        return () => {
            Plotly.purge(el);
        };
    }, [series, x_label, y_label]);
    return (_jsxs("div", { className: "w-full", "data-test": "ai-bar-chart", children: [_jsx("p", { className: "text-base font-semibold text-gray-700 mb-2 text-center", children: title }), _jsx("div", { ref: chartRef })] }));
};
export default AiBarChart;
